<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EP">It is natural for the mind to believe and for the will to love; so that, for want of true objects, they must attach themselves to false.</p>
<p class="EPC"><span class="ePub-B">—Blaise Pascal</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?00fb6633